<template>
  <div>
    <!-- Errors -->
    <div class="px-4 py-2 mb-3 text-red-700 bg-red-200 rounded-md" v-if="form_errors.length">
      <div v-for="error in form_errors" :key="error.message">
        {{ error.message }}
      </div>
    </div>

    <form @submit.prevent="login()" :disabled="submitting" v-if="mode === 'login'">
      <fieldset class="form-group">
        <label class="form-label">Email Address</label>
        <input ref="initial" id="email" class="form-input" type="email" tabindex="1" placeholder="Your Email Address" v-model="form.email" required>
      </fieldset>
      <fieldset class="form-group">
        <label class="items-center justify-between form-label">
          Password 
          <a class="text-xs font-normal tracking-wide uppercase text-accent hover:underline" href="#" @click="showPassword = !showPassword" tabindex="3">
            {{ showPassword ? 'Hide' : 'Show' }} Password
          </a>
        </label>
        <input id="password" class="form-input" :type="showPassword ? 'text' : 'password'" tabindex="2" placeholder="Your Password" v-model="form.password" required>
      </fieldset>
      <button type="submit" class="w-full btn btn-accent" v-submitting="submitting">
        Login
      </button>
      <button type="button" class="block w-full mt-6 text-center hover:underline text-accent" @click="mode = 'reset-password'">
        Reset My Password &rarr;
      </button>
    </form>

    <form @submit.prevent="resetPassword()" :disabled="submitting" v-else-if="mode === 'reset-password'">
      <div v-if="success">
        <div>We've sent your new password to</div>
        <div class="font-bold">{{ form.email }}</div>
      </div>
      <div v-else>
        <p>Enter your email address and we'll email you a new password.</p>
        <fieldset class="mt-4 form-group">
          <label class="form-label">Email Address</label>
          <input ref="initial" id="email" class="form-input" placeholder="Email Address" v-model="form.email">
        </fieldset>
        <button type="submit" class="w-full mb-2 btn btn-accent" v-submitting="submitting">
          Reset Password
        </button>
      </div>
      <button type="button" class="block w-full mt-6 text-center hover:underline text-accent" @click="mode = 'login'">
        &larr; Back to Login
      </button>
    </form>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CustomerAuth',

  props: {
    setMode: {
      type: String
    }
  },

  created () {
    this.setMode ? this.mode = this.setMode : false
  },

  mounted () {
    this.$refs.initial.focus()
  },

  computed: {
    ...mapState(['portal'])
  },

  data () {
    return {
      mode: 'login',
      success: false,
      submitting: false,
      showPassword: false,
      errors: [],
      form_errors: [],
      form: {
        email: '',
        password: ''
      }
    }
  },

  methods: {
    ...mapActions('customer', ['syncCustomer']),

    async login () {
      try {
        this.submitting = true
        const { data } = await this.$api.post(`portal/${this.portal.subdomain}/auth/customer/login`, this.form)
        this.$cookies.remove('token')
        this.$cookies.remove('customer_token')
        this.$cookies.set('customer_token', data.token.token, {
          secure: process.env.NODE_ENV === 'production' ? true : false,
          samesite: process.env.NODE_ENV === 'production' ? 'None' : 'Lax'
        })
        await this.syncCustomer()
        this.$emit('login-success')
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
      } finally { 
        this.submitting = false
      }
    },

    async resetPassword () {
      try {
        this.submitting = true
        await this.$api.post(`portal/${this.portal.subdomain}/auth/customer/reset-password`, this.form)
        this.success = true
      } catch (error) {
        console.error(error)
        this.$toasted.error(error.response.data.message)
        this.errors = error.response.data.errors ? error.response.data.errors : []
        this.form_errors = error.response.data.form_errors ? error.response.data.form_errors : []
      } finally {
        this.submitting = false
      }
    }
  },

  watch: {
    setMode (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.mode = newVal
        this.$refs.initial.focus()
      }
    }
  }
}
</script>